import React from 'react';
import {HashRouter, Route, Routes} from 'react-router-dom'
import ListTrackComponent from './components/ListTrackComponent';
import HeaderComponent from './components/HeaderComponent';
import FooterComponent from './components/FooterComponent';
import ViewTrackComponent from './components/ViewTrackComponent';
import LoginComponent from './components/LoginComponent';
import { RequireAuth } from './utils/RequireAuth';
import styled from 'styled-components';

const AppContainer = styled.div`
  width:100%;
  height:100%;
  min-height:100%;
  display:grid;
  grid-template-rows: 50px 1fr 30px;
`

const ContentContainer = styled.div`
`

function App() {

  return (
    <AppContainer> 
        <HashRouter>
        <HeaderComponent />
        <ContentContainer>
              <Routes>
                <Route path = "/" element = {<LoginComponent/>}></Route>
                <Route path="/login/:message" element={<LoginComponent/>}/>
                  <Route path="/jwt" element={<LoginComponent/>}/>
                  <Route path = "/tracks" element = {
                                                      <RequireAuth>
                                                        <ListTrackComponent />
                                                      </RequireAuth>
                                                    }
                  ></Route>
                  <Route path = "/track/:id" element = {
                                                      <RequireAuth>
                                                        <ViewTrackComponent />
                                                      </RequireAuth>
                                                    }
                  ></Route>
              </Routes>
          </ContentContainer>  
          <FooterComponent />
        </HashRouter>
    </AppContainer>
  );
}

export default App;